import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Only http and https links are valid. Matches urlValidator in @atlas-forms/validation-js, which
 * rejects plain text such as "adasfdf" and dangerous schemes such as "javascript:".
 */
export function isValidWebUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

function renderLinkEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;
  const href = (control.config?.href as string) || '';
  const hrefError = href && !isValidWebUrl(href)
    ? 'Enter a valid URL starting with http:// or https://'
    : undefined;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Link Settings</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          URL
          <input
            type="text"
            value={href}
            onChange={(e) => onConfigChange('href', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="https://..."
            aria-invalid={hrefError ? 'true' : 'false'}
            aria-describedby={hrefError ? 'link-href-error' : undefined}
          />
        </label>
        {hrefError && (
          <div id="link-href-error" className="af-property-editor__error" role="alert">
            {hrefError}
          </div>
        )}
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Open In
          <select
            value={(control.config?.target as string) || '_self'}
            onChange={(e) => onConfigChange('target', e.target.value)}
            className="af-properties-tab__select"
          >
            <option value="_self">Same Tab</option>
            <option value="_blank">New Tab</option>
          </select>
        </label>
      </div>
    </div>
  );
}

export const LinkEditor: PropertyEditor = {
  type: 'link',
  label: 'Link',
  description: 'Configure link URL and target',
  render: renderLinkEditor,
};
